
import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 

import TextField from '@mui/material/TextField';





import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';


import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';



import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const headCells = [

	{ id: 'no_date', numeric: false, label: 'Date '},
	{ id: 'no_remiderdate', numeric: false, label: 'Reminder Date' },
	{ id: 'no_title', numeric: false, label: 'Title' },
	{ id: 'type', numeric: false, label: 'Type' },
	{ id: 'optiontype', numeric: false, label: 'Customer Type/Staff' },
	{ id: 'classtype', numeric: false, label: 'Class Type' },
	{ id: 'no_description', numeric: false, label: 'Desc' },
	{ id: 'no_file', numeric: false, label: 'File' },
 
 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});




export default class AdminNotification extends Component {
	
    constructor(props) {
    super(props);
   const now = dayjs();
const startOfMonth = now.startOf('month');
const today = now;
     this.state = {
		 ExportData:[],no_title:'',no_description:'',no_file:'',
		 redirect: false,editredirect: false,no_id:'',no_date:'',fb_staff:0,no_remiderdate:'',type:'',exportdata:[],
		 //fromdate:dayjs(Date.now()),fromdate1:'',todate:dayjs(Date.now()),todate1:'',
		 fromdate: startOfMonth,
  fromdate1: startOfMonth.format('YYYY-MM-DD'),
  todate: today,
  todate1: today.format('YYYY-MM-DD'),
     Notificationdata:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],rolelabel:'Select Staff',staff:'',staffarray:[],subscribeData:[],subid:'',no_type:'',
	 
	  order:'desc' ,orderBy:'',
	          
      }
	  this.updateDonenewParent = this.updateDonenewParent;
	}
	  



	


handleChangePage = (event, newPage) => {  

  
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  	 myChangeHandler = (event) => {
	
	
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}

   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };  

componentWillMount  () {
	

	
	document.title = "AthaYog Living - Feedback";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }

	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  this.apiExportcall();
}

apicall(page,rowsPerPage){
	
 axios.get(Serverurl+'ajaxnotifications.php?action=getall&StartIndex='+page+'&PageSize='+rowsPerPage+'&no_type='+this.state.no_type+'&no_date='+this.state.fromdate1+'&no_todate='+this.state.todate1+'&no_title='+this.state.no_title)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Notificationdata:resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
		
			
	 
     }
	 else{
		   this.setState({Notificationdata:[],totaldata:0});
	 }
 
    });
}

apiExportcall(){
	
 axios.get(Serverurl+'ajaxnotifications.php?action=getall&no_type='+this.state.no_type+'&no_date='+this.state.fromdate1+'&no_todate='+this.state.todate1+'&no_title='+this.state.no_title)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  ExportData:resp.data,  
			   
			   

		    });
		
			
		
			
	  
	
	 
     }
	 else{
		   this.setState({ExportData:[]});
	 }
 
    });
}










 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
 

	  

  
handfromChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
todate: todate1,
todate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtoChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }

handleClickSearch=()=>{   
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
	this.apiExportcall();
} 

render() {
	
	
	if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 

 <React.Fragment>
 
  <div className="mainheading"><h1>Notification Report</h1></div>

<div className="clear"></div>

	
	

 <div className="searchmaster">
 <ul>
   <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox" 
    onChange={this.handfromChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox" 
    onChange={this.handtoChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 <li><p>Title</p>
 <p><TextField name="no_title" 
	   onChange={this.myChangeHandler} 
	   fullWidth 		 	 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   value={this.state.no_title}
                          /></p>
 
 </li>
 <li>	
		 <p>Type</p> 
		  <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.no_type}
		 inputProps={{ tabIndex: "3" }}
          onChange={this.myChangeHandler} className="txtbox"
        name='no_type'
         id='no_type'
		 fullWidth
		 
        >
		   
          <option value={''}>Select Type</option>
          <option value={1}>Staff</option>
          <option value={2}>Customer</option>
		  
          </Select>
      </FormControl>
		  	   </p>
			   </li>
				
					<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;
		<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="Notificationreport"
							filename="Notification Repor"
							sheet="Notification Report"
							buttonText="EXPORT"/>
							
			
							
				</p>		
		</li>
		
		
		</ul>
		
</div>	
	<div ref={el => (this.componentRef = el)}  >
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Notificationdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Notificationdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell >{item.nodate}</TableCell>
<TableCell >{item.remiderdate}</TableCell>
<TableCell >{item.no_title}</TableCell>
<TableCell >{item.type}</TableCell>
<TableCell >{item.optiontype}</TableCell>
<TableCell >{item.classtype}</TableCell>
<TableCell  style={{"width":"200px"}}>{item.no_description}</TableCell>
<TableCell ><a href={Serverurl+'uploads/'+item.no_file}> View</a></TableCell>


 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      /> 
  </Paper>
    

</div>





<div style={{"display":"none"}}>
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="Notificationreport">  
<TableHead> 
<TableRow>
                                              
      <TableCell>Date</TableCell>                 
			 <TableCell>Remainder Date</TableCell>
 <TableCell>Title</TableCell> 
 <TableCell>Type</TableCell>   <TableCell>Customer Type</TableCell>
  <TableCell>Preference </TableCell>  <TableCell>Desc </TableCell>
    <TableCell>File </TableCell>
                      </TableRow></TableHead>
					  
					  
                      <TableBody>
                     {stableSort(this.state.ExportData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.nodate}</TableCell>
<TableCell>{item.remiderdate}</TableCell>
<TableCell>{item.no_title}</TableCell>
<TableCell>{item.type}</TableCell>
<TableCell >{item.optiontype}</TableCell>
<TableCell >{item.classtype}</TableCell>
<TableCell>{item.no_description}</TableCell>
<TableCell>{Serverurl+'uploads/'+item.no_file}</TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
 
</div>


 </React.Fragment>
 



);


		}
	
}

